const LocationBadge = ({ children }) => {

  return (
    <div className="dark:bg-gray-400 bg-gray-200 border dark:border-gray-500 border-gray-300 rounded-md p-1 text-sm">
      {children}
    </div>

  );
};

export default LocationBadge;
